
import './hd.scss';

interface Props {
    onClose: () => void;
}

export default function HDRH(props: Props) {
    const { onClose } = props;
    return (
        <>
          <div className="hdRh">          
            <section className="hd-txcb">
                <div className="wrapper">
                    <div className="title">HƯỚNG DẪN CHƠI</div>
                    <div className="close" onClick={onClose}>
                        <img src={require(`assets/images/txcanban/statis/close.png`)} alt='' />
                    </div>
                    <div className="inner">
                        <div className="tblBottomScroll">
                            <div className="content">
                                <div className="hd"><b>1. Rồng Hổ</b> Trò chơi Rồng Hổ Mini sử dụng bộ bài tú lơ khơ 52 lá (bỏ đi 2 lá Joker). </div>

                                <div className="hd">
                                    <b>2. HƯỚNG DẪN CHƠI:</b><br></br>
                                    <ul>
                                        <li>Bộ bài sẽ được sử dụng thuật toán xáo đều sau đó mới được chia ngẫu nhiên 2 quân bài cho của Rồng và cửa Hổ.</li>
                                        <li>Thứ tự các quân bài từ to đến nhỏ như sau: K &gt; Q &gt; J &gt; 10 &gt; 9 &gt; 8 &gt; 7 &gt; 6 &gt; 5 &gt; 4 &gt; 3 &gt; 2 &gt; A</li>
                                        <li>Lá to nhất là K và nhỏ nhất là A.</li>
                                        <li>Người chơi dự đoán kết quả bằng cách cược vào các cửa Rồng, Hổ, Hoặc Hòa</li>
                                        <li>Lưu ý, người chơi không thể cùng đặt cả cửa rồng và cửa hổ cùng một phiên, mà chỉ có thể đặt cược thêm của Hòa.</li>
                                    </ul>
                                
                                </div>
                                <div className="hd">
                                    <b>2. TRẢ THƯỞNG:</b>
                                    <ul>
                                        <li>Sau khi kết thúc thời gian cược, 2 lá bài Rồng và Hổ được mở, người chơi sẽ đươc trả thưởng nếu dự đoán đúng.</li>
                                        <li>Đặt cược cửa Rồng: Tỷ lệ 1 ăn 1</li>
                                        <li>Ví dụ: Đặt cược 100.000đ cửa Rồng, nếu thắng cược nhận được 100.000đ</li>
                                        <li>Đặt cược cửa Rồng: Tỷ lệ 1 ăn 1</li>
                                        <li>Ví dụ: Đặt cược 100.000đ cửa Hổ, nếu thắng cược nhận được 100.000đ</li>
                                        <li>Đặt cược cửa Hòa: Tỷ lệ 1 ăn 8</li>
                                        <li>Ví dụ: Đặt cược 100.000đ cửa Tie, nếu thắng cược nhận được 800.000đ</li>
                                    </ul>
                                </div>
                                <div className="hd">
                                    <b>3. CHAT TƯƠNG TÁC:</b>
                                    <ul>
                                        <li>Người chơi có thể chat, nhắn tin cùng các người chơi khác để cùng trải nghiệm trò chơi trên hệ thống</li>
                                        <li>
                                            lưu ý để tránh spam tin nhắn rác nên chỉ những người chơi có tài khoản từ 20,000 VNĐ trở lên mới có thể sử dụng chức năng chat nhóm này
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        </>
    );
}
